// extracted by mini-css-extract-plugin
export default {"separator":"styles_separator__OG5kL","higherPointsList":"styles_higherPointsList__JtsHJ","lowerAlphaList":"styles_lowerAlphaList__Gv+RL"};